import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { SchedulingOverviewComponent } from './scheduling-overview/scheduling-overview.component';
import { DeliveryOverviewComponent } from './delivery-overview/delivery-overview.component';
import { DeliveryDetailComponent } from './delivery-detail/delivery-detail.component';
import { DeliveryFlyoutComponent } from './delivery-flyout/delivery-flyout.component';
import { DeliveryHistoryComponent } from './delivery-history/delivery-history.component';
import { VendorPickupOverviewComponent } from 'app/purchase-orders/vendor-pickup-overview/vendor-pickup-overview.component';
import { BuildSchedulerComponent } from './build-scheduler/build-scheduler.component';
import { OptionsDialogComponent } from './options-dialog/options-dialog.component';
import { OrderSchedulerComponent } from 'app/orders/order-scheduler/order-scheduler.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'schedule',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    {
                        path: 'assembly',
                        component: SchedulingOverviewComponent,
                        data: { title: 'Assembly Schedule', mode: 'assembly' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'shipping',
                        component: SchedulingOverviewComponent,
                        data: { title: 'Shipping Schedule', mode: 'shipping' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'stacks',
                        component: DeliveryOverviewComponent,
                        data: { title: 'Stack Overview', mode: 'stack' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'deliveries',
                        component: DeliveryOverviewComponent,
                        data: { title: 'Delivery Overview', mode: 'delivery' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'vendor-pickup',
                        component: VendorPickupOverviewComponent,
                        data: { title: 'Vendor Pickup Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    { path: 'history', component: DeliveryHistoryComponent, data: { title: 'History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'deliveries/:id', component: DeliveryDetailComponent, data: { title: 'Delivery Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'build-scheduler', component: BuildSchedulerComponent, data: { title: 'Schedule' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'scheduler', component: OrderSchedulerComponent, data: { title: 'Scheduler' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        SchedulingOverviewComponent,
        DeliveryOverviewComponent,
        DeliveryDetailComponent,
        DeliveryFlyoutComponent,
        DeliveryHistoryComponent,
        BuildSchedulerComponent,
        OptionsDialogComponent,
    ],
})
export class SchedulingModule {}
